import React from "react";
import { useIntersectionObserver } from "react-weekly-planning";

/**
 * Render optimization via Intersection Observer (skips rendering of off-screen items)
 */
const VirtualItem: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const ref = React.useRef<HTMLDivElement>(null);
    const { entry, height } = useIntersectionObserver(ref, {
        rootMargin: "0px",
        threshold: 0,
    });

    const isVisible = !!entry?.isIntersecting;

    return (
        <div
            ref={ref}
            style={{ minHeight: isVisible ? "auto" : `${height}px` }}
        >
            {isVisible ? children : null}
        </div>
    );
};
export default VirtualItem;